import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2b185edc"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "sellers_views_title" }, "Liste des clients :", -1))
const _hoisted_2 = { id: "actions_and_filters" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "active_sellers_accounts" }, "Filtrer par : comptes actifs", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "inactive_sellers_accounts" }, "Filtrer par : comptes innactifs", -1))
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = { class: "checked_names_all_actions" }
const _hoisted_7 = {
  key: 1,
  id: "div_checked_names_all_actions"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Ouvir la page facebook", -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Ouvrir la conversation messenger", -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Facturer", -1))
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { id: "checkall_checkbox" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "checkAll" }, "Tout sélectionner", -1))
const _hoisted_17 = { class: "seller_infos" }
const _hoisted_18 = ["id", "value", "onUpdate:modelValue", "checked", "onChange"]
const _hoisted_19 = ["for"]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_21 = { key: 0 }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = ["onClick"]
const _hoisted_24 = ["onClick"]
const _hoisted_25 = { key: 1 }
const _hoisted_26 = ["onClick"]
const _hoisted_27 = { key: 1 }
const _hoisted_28 = ["onClick"]
const _hoisted_29 = ["onUpdate:modelValue", "onInput"]
const _hoisted_30 = ["onClick"]
const _hoisted_31 = ["onClick"]
const _hoisted_32 = { key: 2 }
const _hoisted_33 = ["onClick"]
const _hoisted_34 = { key: 1 }
const _hoisted_35 = ["onUpdate:modelValue", "onInput"]
const _hoisted_36 = ["onClick"]
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NavView = _resolveComponent("NavView")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_NavView),
    _hoisted_1,
    _createElementVNode("span", _hoisted_2, [
      _withDirectives(_createElementVNode("select", {
        name: "list_sellers_account_filter",
        id: "list_sellers_accounts_filter_option",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filterValue) = $event)),
        onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.update_ordered_sellers_list && _ctx.update_ordered_sellers_list(...args)))
      }, _hoisted_5, 544), [
        [_vModelSelect, _ctx.filterValue]
      ]),
      _createElementVNode("span", _hoisted_6, [
        (_ctx.checkedNames.length !== 0)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.checkedNamesAllActions = !_ctx.checkedNamesAllActions))
            }, "Plus d'actions"))
          : _createCommentVNode("", true),
        (_ctx.checkedNamesAllActions && _ctx.checkedNames.length !== 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("div", {
                class: "checked_names_action",
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.get_sellers_facebook_pages_link && _ctx.get_sellers_facebook_pages_link(...args)))
              }, _hoisted_9),
              _createElementVNode("div", {
                class: "checked_names_action",
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.get_sellers_messenger_chat_link && _ctx.get_sellers_messenger_chat_link(...args)))
              }, _hoisted_11),
              _createElementVNode("div", {
                class: "checked_names_action",
                onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.get_sellers_infos_for_billing && _ctx.get_sellers_infos_for_billing(...args)))
              }, _hoisted_13)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    (_ctx.showSellersList && _ctx.sellersList.length > 0)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              name: "checkAll",
              id: "checkAll",
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.selectAll) = $event)),
              onChange: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.updateAllCheckedNames && _ctx.updateAllCheckedNames(...args)))
            }, null, 544), [
              [_vModelCheckbox, _ctx.selectAll]
            ]),
            _hoisted_16
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.orderedSellers, (seller, index) => {
            return (_openBlock(), _createElementBlock("li", {
              key: seller.id
            }, [
              _createElementVNode("span", {
                class: _normalizeClass(["seller", _ctx.add_color_to_a_seller_s_display(seller.accountState)])
              }, [
                _createElementVNode("span", _hoisted_17, [
                  _createElementVNode("div", null, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      name: "checkbox_seller",
                      id: 'checkbox_' +index,
                      value: seller.techName,
                      "onUpdate:modelValue": ($event: any) => ((seller.isChecked) = $event),
                      checked: _ctx.checkedNames.includes(seller.techName),
                      onChange: ($event: any) => (_ctx.updateCheckedNames(seller.techName))
                    }, null, 40, _hoisted_18), [
                      [_vModelCheckbox, seller.isChecked]
                    ]),
                    _createElementVNode("label", {
                      for: 'checkbox_' +index
                    }, _toDisplayString(seller.adminName) + " (" + _toDisplayString(seller.techName) + ")", 9, _hoisted_19),
                    _createTextVNode(),
                    _hoisted_20
                  ]),
                  (seller.activateOrDeactivateSellerAccount)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_21, [
                        (seller.displayDeleteSellerButton)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              href: "#",
                              onClick: ($event: any) => (_ctx.deactivate_seller_account(seller))
                            }, "Désactiver le compte", 8, _hoisted_22))
                          : (_openBlock(), _createElementBlock("button", {
                              key: 1,
                              href: "#",
                              onClick: ($event: any) => (_ctx.activate_seller_account(seller))
                            }, "Activer le compte", 8, _hoisted_23))
                      ]))
                    : _createCommentVNode("", true)
                ]),
                (seller.sellerNoteDoesNotExist && seller.newSellerNote === false)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      href: "#",
                      onClick: ($event: any) => (_ctx.updateNewSellerNote(seller), _ctx.updateDisplayNewNote(seller))
                    }, "Ajouter notes", 8, _hoisted_24))
                  : _createCommentVNode("", true),
                (seller.sellerNoteDoesNotExist === false)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_25, [
                      (seller.displayNote)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 0,
                            href: "#",
                            onClick: ($event: any) => (_ctx.updateDisplayNote(seller))
                          }, "Masquer notes", 8, _hoisted_26))
                        : _createCommentVNode("", true),
                      _createTextVNode(),
                      (seller.displayNote)
                        ? (_openBlock(), _createElementBlock("br", _hoisted_27))
                        : (_openBlock(), _createElementBlock("a", {
                            key: 2,
                            href: "#",
                            onClick: ($event: any) => (_ctx.updateDisplayNote(seller))
                          }, "Voir notes", 8, _hoisted_28)),
                      (seller.displayNote)
                        ? _withDirectives((_openBlock(), _createElementBlock("textarea", {
                            key: 3,
                            name: "note",
                            cols: "50",
                            rows: "3",
                            "onUpdate:modelValue": ($event: any) => ((seller.sellerNote) = $event),
                            onInput: ($event: any) => (_ctx.updateDisplayRegisterButton(seller))
                          }, null, 40, _hoisted_29)), [
                            [_vModelText, seller.sellerNote]
                          ])
                        : _createCommentVNode("", true),
                      (seller.displayNote && seller.displayRegisterButton)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 4,
                            onClick: ($event: any) => (_ctx.update_seller_note(seller))
                          }, "Enregistrer", 8, _hoisted_30))
                        : _createCommentVNode("", true),
                      (seller.displayNote && seller.sellerNote !== '')
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 5,
                            onClick: ($event: any) => (_ctx.update_seller_note(seller), seller.sellerNote = '', _ctx.updateDisplayRegisterButton(seller))
                          }, "Supprimer", 8, _hoisted_31))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (seller.newSellerNote && seller.sellerNoteDoesNotExist)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_32, [
                      (seller.displayNewNote)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 0,
                            href: "#",
                            onClick: ($event: any) => (_ctx.updateNewSellerNote(seller), _ctx.updateDisplayNewNote(seller))
                          }, "Masquer notes", 8, _hoisted_33))
                        : _createCommentVNode("", true),
                      _createTextVNode(),
                      (seller.displayNewNote)
                        ? (_openBlock(), _createElementBlock("br", _hoisted_34))
                        : _createCommentVNode("", true),
                      (seller.displayNewNote)
                        ? _withDirectives((_openBlock(), _createElementBlock("textarea", {
                            key: 2,
                            name: "note",
                            cols: "50",
                            rows: "3",
                            "onUpdate:modelValue": ($event: any) => ((seller.sellerNote) = $event),
                            onInput: ($event: any) => (_ctx.updateDisplayRegisterButton(seller))
                          }, null, 40, _hoisted_35)), [
                            [_vModelText, seller.sellerNote]
                          ])
                        : _createCommentVNode("", true),
                      (seller.displayNewNote && seller.displayRegisterButton)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 3,
                            onClick: ($event: any) => (_ctx.update_seller_note(seller))
                          }, "Enregistrer", 8, _hoisted_36))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ], 2),
              _hoisted_37
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ], 64))
}